<template>
    <div>
        <section class="relative">
            <div class="banner-mask"></div>
            <img class="banner" :src="cruiseInfo.image" />
            <div class="title">
                <h1>{{ cruiseInfo.name }}</h1>
                <h2>{{ cruiseInfo.en_name }}</h2>
            </div>
            <div class="main-width absolute bread">
                <VBreadcrumb theme="white" :options="[{ label: '首页', to: '/' }, {label: cruiseInfo.name}]"></VBreadcrumb>
            </div>
        </section>
        <section class="box">
            <div class="main-width">
                <div class="holday-filter">
                    <div class="filter-row">
                        <filter-bar
                            name="邮轮公司"
                            :options="filter.company"
                            :is-all="queryData.company.length == 0"
                            @on-clear="handleClearQuery('company')"
                            v-if="filter.company && filter.company.length"
                        >
                            <template #item="{option}">
                                <v-checkbox
                                    :val="option.id"
                                    v-model="queryData.company"
                                    @change="handleFitlerChange"
                                >
                                    {{ option.name }}
                                </v-checkbox>
                            </template>
                        </filter-bar>
                        <filter-bar
                            name="出游日期"
                            :options="filter.months"
                            :is-all="queryData.months.length == 0"
                            @on-clear="handleClearQuery('months')"
                            type="group"
                            v-if="filter.months && filter.months.length"
                        >
                            <template #item="{option}">
                                <v-checkbox
                                    :val="option.value"
                                    v-model="queryData.months"
                                    @change="handleFitlerChange"
                                >
                                    {{ option.key }}
                                </v-checkbox>
                            </template>
                        </filter-bar>
                    </div>
                </div>
                <product-list
                    :listData="listData"
                    :loading="loading"
                    @change="listQueryChange"
                    :initSort='[queryData.sort_name]'
                    :initSortType="queryData.sort_type"
                    :pageIndex="queryData.page_index"
                ></product-list>
            </div>
        </section>
    </div>
</template>
<script>
    import { defineComponent, useMeta, toRaw } from '@nuxtjs/composition-api';
    import FilterBar from "@/components/product/filterBar";
    import ProductList from "@/components/product/productList";
    import { getGoods,getFilter } from "@/services/themeCruise";
    import VBreadcrumb from '@/components/VBreadcrumb.vue'

    export default defineComponent({
        name:"ThemeCruise",
        auth: false,
        head: {},
        layout: 'Main',
        components: { FilterBar,ProductList,VBreadcrumb},
        head: {
            title: '主题邮轮'
        },
        setup() {

        },
        data(){
            return {
                listData:{},
                loading:false,
                filter:{},
                queryData:{
                    id:null,
                    company:[],
                    months:[],
                    sort_type:'',
                    sort_name:'1',
                    page_index:1,
                    page_size:10,
                },
                cruiseInfo:{}
            }
        },
        methods:{
            formatDateGroup(dates){
                let res = []
                if(!dates){
                    return []
                }
                const keys = Object.keys(dates);
                for(let i=0;i<keys.length;i++){
                    let obj = {}
                    const key = keys[i]
                    obj.group = key+'年'
                    obj.value = dates[key]
                    res.push(obj)
                }
                return res
            },
            handleClearQuery(key) {
                this.queryData[key] = [];
                this.$nextTick(this.handleFitlerChange);
            },
            handleFitlerChange() {
                this.queryData.page_index = 1
                this.getLists(this.queryData)
            },
            listQueryChange(val){
                this.queryData.page_index = val.page_index
                this.queryData.page_size = val.page_size
                this.queryData.sort_name = val.sort_name
                this.queryData.sort_type = val.sort_type

                this.getLists(this.queryData)
            },
            async getLists(params){
                this.$router.replace({
                    query: toRaw(params)
                });
                this.loading = true
                const { data, code, msg } = await getGoods(params)
                console.log('list data', data)
                this.loading = false
                if (code === 10000 || code === 200) {
                    this.listData = data;
                } else {
                    this.$message({
                        type: "error",
                        text: msg
                    });
                }
            },
            async getData(){
                const { query } = this.$route;
                if(query.page_index){
                    query.page_index = Number(query.page_index)
                }
                if(query.page_size){
                    query.page_size = Number(query.page_size)
                }
                this.queryData = {...this.queryData,...query}

                await this.getLists(this.queryData)   
                const { code, msg, data } = await getFilter({id:query.id})
                console.log('filter data', data)
                if (code === 10000 || code === 200) {
                    this.filter = {
                        months:this.formatDateGroup(data.date),
                        company:data.company
                    }
                    this.cruiseInfo = {
                        image:data.image,
                        name:data.name,
                        en_name:data.en_name
                    }
                } else {
                    this.$message({
                        type: "error",
                        text: msg
                    });
                }
            },
        },
        async fetch(){
            await this.getData()
        },
        watch:{
            $route:async function(val,oldVal){
                console.log(val)
                if(val.path == oldVal.path && val.query.id == oldVal.query.id ){
                    return
                }
                this.queryData = {
                    id:null,
                    company:[],
                    months:[],
                    sort_type:'',
                    sort_name:'1',
                    page_index:1,
                    page_size:10,
                }
                await this.getData()
            }
        }
    })
</script>
<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 280px;
  display: block;
  object-fit: cover;
}
.banner-mask {
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  background-color: rgba(0,0,0,.3);
}
.title {
  text-align: center;
  color: #fff;
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.title h1 {
  font-size: 52px;
  font-weight: 500;
}
.title h2 {
  font-size: 26px;
}
.bread {
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  z-index: 1;
  padding: 20px 0;
}
.box {
  background-color: #fff;
  padding-bottom: 98px;
  padding-top: 40px;
}
.holday-filter {
  background: linear-gradient(180deg, #F3F5F8 0%, rgba(255,255,255,0) 100%);
  box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.1);
  border-radius: 20px 20px 0 0;
}
.holday-filter .filter-row {
  padding: 20px 28px;
}
</style>